import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 20.5C5.25328 20.5 1 16.2467 1 11C1 5.75328 5.25328 1.5 10.5 1.5C15.7467 1.5 20 5.75328 20 11C20 16.2467 15.7467 20.5 10.5 20.5ZM9.40407 7.35286V12.0904C9.40407 12.4936 9.73081 12.8275 10.134 12.8275H10.866C11.2728 12.8275 11.596 12.4977 11.596 12.0904V7.35286C11.596 6.95017 11.2692 6.61578 10.866 6.61578H10.134C9.72725 6.61578 9.40407 6.94609 9.40407 7.35286ZM9.40407 14.6538V15.3858C9.40407 15.7926 9.73081 16.1157 10.134 16.1157H10.866C11.2728 16.1157 11.596 15.789 11.596 15.3858V14.6538C11.596 14.247 11.2692 13.9233 10.866 13.9233H10.134C9.72725 13.9233 9.40407 14.2506 9.40407 14.6538Z"
      fill="url(#paint0_linear_7171_19814)"
    />
    <path
      d="M0.5 11C0.5 16.5229 4.97714 21 10.5 21C16.0229 21 20.5 16.5229 20.5 11C20.5 5.47714 16.0229 1 10.5 1C4.97714 1 0.5 5.47714 0.5 11ZM9.90407 12.0904V7.35286C9.90407 7.21587 10.0097 7.11578 10.134 7.11578H10.866C10.9866 7.11578 11.096 7.21975 11.096 7.35286V12.0904C11.096 12.2277 10.9905 12.3275 10.866 12.3275H10.134C10.0132 12.3275 9.90407 12.2238 9.90407 12.0904ZM9.90407 15.3858V14.6538C9.90407 14.5247 10.0054 14.4233 10.134 14.4233H10.866C10.9942 14.4233 11.096 14.5243 11.096 14.6538V15.3858C11.096 15.5144 10.995 15.6157 10.866 15.6157H10.134C10.0054 15.6157 9.90407 15.5148 9.90407 15.3858Z"
      stroke="white"
      strokeOpacity={0.7}
    />
    <defs>
      <linearGradient
        id="paint0_linear_7171_19814"
        x1={10.5}
        y1={1.5}
        x2={10.5}
        y2={20.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1506" />
        <stop offset={1} stopColor="#260503" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
